import React from 'react';
import {PropTypes} from 'prop-types';
import {connect} from 'react-redux';
import DialogueTitle from 'components/DialogueTitle';
import DialogueButtons from 'components/DialogueButtons';
import Modal from 'react-modal';
import Resources from 'utilities/Resources';
import 'styles/exports.scss';

class EditPresetErrorDialogue extends React.Component {
  static propTypes = {
    showUpdatePresetDialogue: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
  };

  close = () => {
    this.props.onClose();
  };

  render() {
    const resources = Resources.localizedString;
    return (
      <Modal
        className={"dialogue"}
        contentLabel="Update Preset Modal"
        onRequestClose={this.onClose}
        onClose={this.onclose}
        isOpen={this.props.showUpdatePresetDialogue}
        style={{
          content: {
            width: 950,
            height: 370
          }
        }}>
        <DialogueTitle title="Save Failed" />
        <div className="padded margin-vertical">
          <div className="padded margin-vertical text-center">
            <span className="status-icon status-icon--error margin-bottom"></span>
            <p className="margin-top">{resources.anErrorOccurredSavingPreset}</p>
            <p>{resources.pleaseTryAgainInFewMinutes}</p>
          </div>
        </div>
        <DialogueButtons
          showCancelButton={false}
          confirmFunction={this.close}
          confirmButtonText={resources.ok} />
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
  };
}

function mapDispatchToProps(dispatch) {
  return {
  };
}
export {EditPresetErrorDialogue as EditPresetErrorDialogueNoRedux};

const ConnectedEditPresetErrorDialogue = connect(mapStateToProps, mapDispatchToProps)(EditPresetErrorDialogue);
export default ConnectedEditPresetErrorDialogue;
